import { Injectable } from '@angular/core';
import { Router,  ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { LoginService } from '../services/login.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    if (this.loginService.isAuthenticated()) {
      return true;
    }
    /*
    // old code
     if (state.url === '/') {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    }
    */
   //console.log(state.url)
   localStorage.setItem('returnUrl', state.url);
   this.loginService.redirectUrl=state.url;
   
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

    return false;
  }

}
